import { create } from "zustand";

/**
 * useCadastroCoresListaFilters
 */

type State = {
  cor: string | null;
  dataDe: Date | null;
  dataAte: Date | null;
};

export const initialCadastroCoresListaState: State = {
  cor: null,
  dataDe: null,
  dataAte: null,
};

export const useCadastroCoresListaFilters = create<State>((set) => ({
  ...initialCadastroCoresListaState,
}));